module.exports = __webpack_public_path__ + "static/Equalizer-e25c482becd83fa3e1a2f99d854e825a.png";